/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable no-console */
import { API } from 'aws-amplify';
function init(arg0:string, arg1:string, _init:any, any:any)
{
	throw new Error('Function not implemented.');
}

export function getFolder(queryStringParameters:any, path:any)
{
	return API.get('folderManagement', `/${path}`, { queryStringParameters });
}

export function getFolder2(queryStringParameters:any)
{
	return API.get('folderManagement', `/folders${queryStringParameters}`, init);
}

export function getFolderById(queryStringParameters:any)
{
	return API.get('folderManagement', '/getFolderById', { queryStringParameters });
}

export function updateFolder(queryStringParameters:any, body:any)
{
	return API.put('folderManagement', '/folders', { queryStringParameters, body });
}
export function getSharedItems(query:any)
{
	return API.get('folderManagement', `/getSharedItems${query}`, init);
}

export function creatFolder(queryStringParameters:any, body:any)
{
	return API.post('folderManagement', '/folders', { queryStringParameters, body });
}
export function existFolder(queryStringParameters:any, body:any)
{
	return API.post('folderManagement', '/checkExist', { queryStringParameters, body });
}
export function existFolderEdm(queryStringParameters:any, body:any)
{
	return API.post('folderManagement', '/existEDM', { queryStringParameters, body });
}
export function getRelation(queryStringParameters:any)
{
	return API.get('folderManagement', `/getRelations/${queryStringParameters}`, init);
}
export function getBreadCrumbs(queryStringParameters:any)
{
	return API.get('folderManagement', '/getParentPath', { queryStringParameters });
}
export function updateFloderName(queryStringParameters:any, body:any)
{
	return API.put('folderManagement', '/folders', { queryStringParameters, body });
}
export function uploadFolder(queryStringParameters:any, body:any)
{
	return API.post('folderManagement', '/nestedFolder', { queryStringParameters, body });
}
export function getMoveFolders(queryStringParameters:any)
{
	return API.get('folderManagement', `/moveGet${queryStringParameters}`, init);
}
export function moveFolder(queryStringParameters:any, body:any)
{
	return API.put('folderManagement', '/move', { queryStringParameters, body });
}
export function moveTrash(body:any)
{
	return API.put('folderManagement', '/movetrash', { body });
}
export function getTrashFolders(queryStringParameters:any)
{
	return API.get('folderManagement', '/gettrash', { queryStringParameters });
}
export function restoreFolder(queryStringParameters:any, body:any)
{
	return API.post('folderManagement', '/restore', { queryStringParameters, body });
}
export function deleteFolder(queryStringParameters:any, body:any)
{
	return API.del('folderManagement', '/folders', { queryStringParameters, body });
}
export function permanentDelete(queryStringParameters:any, body:any)
{
	return API.del('folderManagement', '/folders', { queryStringParameters, body });
}
export function searchFolders(query:any)
{
	return API.get('folderManagement', `/search${query}`, init);
}
export function searchEdmFolders(query:any)
{
	return API.get('folderManagement', `/EDM${query}`, init);
}
export function searchWhiteLabel(query:any)
{
	return API.get('folderManagement', `/whitelabel${query}`, init);
}
export function checkRestore(queryStringParameters:any, body:any)
{
	return API.post('folderManagement', '/checkRestore', { queryStringParameters, body });
}
export function getSharedList(queryStringParameters)
{
	return API.get('folderManagement', '/getSharedItems', { queryStringParameters });
}
export function getEmployeeData(queryStringParameters:any)
{
	return API.get('folderManagement', '/employeefolder', { queryStringParameters });
}
export function checkStorage(body:any)
{
	return API.post('folderManagement', '/storage', { body });
}
export function fetchMeetingRecords(queryStringParameters:any)
{
	return API.get('folderManagement', '/getMeetingData', { queryStringParameters });
}